import { atom } from 'jotai';


const settingsAtom = atom({});

export { settingsAtom };